import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SCHOOL_COMMERCIALS_BY_SCHOOL_ID } from "../apiRoutes";

export interface SchoolCommercialDetailsResponse {
  data: unknown;
}

const fetchSchoolCommercialBySchoolId = async (schoolId: string) => {
  const response = await axiosAuth.get<SchoolCommercialDetailsResponse>(
    `${SCHOOL_COMMERCIALS_BY_SCHOOL_ID}${schoolId}`
  );
  return response.data;
};

export const useGetSchoolCommercialBySchoolIdQuery = (
  schoolId: string,
  queryParams?: Omit<
    UseQueryOptions<
      SchoolCommercialDetailsResponse,
      Error,
      SchoolCommercialDetailsResponse,
      ["schoolCommercial", string]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<
    SchoolCommercialDetailsResponse,
    Error,
    SchoolCommercialDetailsResponse,
    ["schoolCommercial", string]
  >({
    queryKey: ["schoolCommercial", schoolId],
    queryFn: () => fetchSchoolCommercialBySchoolId(schoolId),
    enabled: !!schoolId,
    ...(queryParams || {}),
  });


